import React, {PureComponent} from "react"
import gql from "graphql-tag"
import {Query, QueryResult} from "react-apollo"
import {Query as QueryComponent} from "@irati/utils/services/apollo"
import partialUser from "@irati/identity/services/fragments/PartialUser"

import {PollList} from "@irati/types"

const query = gql`
  query Polls($filter: String, $offset: Int, $limit: Int) {
    polls(filter: $filter, offset: $offset, limit: $limit) @connection(key: "open_polls") {
      results {
        uuid
        createdAt
        endsAt
        title
        desc
        active
        private
        teams {
          results {
            uuid
            public_name
          }
        }
        createdBy {
          ...partialUser
        }
        trophy {
          alt
          href
        }
        votes {
          results {
            uuid
            createdBy {
              ...partialUser
            }
            user {
              ...partialUser
            }
          }
        }
        companyValues {
          results {
            archived
            name
            tag
            uuid
            icon {
              href
              alt
            }
          }
        }
      }
    }
  }

  ${partialUser}
`

interface OpenPollsVariables {
  limit: number
  offset: number
}

interface OpenPollsData {
  polls: PollList
}

export type OpenPolls = QueryResult<OpenPollsData, OpenPollsVariables>

interface Props {
  variables?: OpenPollsVariables
  useError?: boolean
  useLoader?: boolean
}

const variables = {
  limit: 100,
  offset: 0
}

// @todo used by web
// Once web is refactored to use QueryComponent delete this
export const openPollsQuery = {
  query,
  variables
}

class TypedQuery extends Query<OpenPolls> {}

export default class OpenPollsQuery extends PureComponent<Props> {
  static defaultProps = {
    variables,
    useError: true,
    useLoader: true
  }

  render() {
    return <QueryComponent {...this.props} query={query} QueryComponent={TypedQuery} notifyOnNetworkStatusChange />
  }
}
